import React from "react";
import {Button, OverlayTrigger, Popover} from "react-bootstrap";

const SearchPartsInfoOverlay = () => (
    <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="right"
        overlay={
            <Popover id={`popover-positioned-right`}>
                <Popover.Title as="h3">İnternet Parça Arama
                    (Beta)</Popover.Title>
                <Popover.Content>
                    <strong>Bu sistem, servislerin parça
                        maliyetleri hakkında anında bilgi
                        sahibi olmasını sağlayarak, teklif
                        oluşturma ve fiyatlandırma sürecini hızlandırır ve
                        kolaylaştırır.</strong>
                    <br/><br/>
                    Daha kesin ve doğru sonuçlar elde etmek
                    için:

                    <ul>
                        <li>Parça adını yazarken, anahtar
                            kelimeleri net bir şekilde
                            eklemek önemlidir. Örneğin, "Sağ ön led far,sağ ön xenon far vs..." olarak
                            belirtilmelidir.
                        </li>
                        <li>Araç marka,model,kasa kodu(F30 , Megane 4, Clio 3 , vs...) üretim yılı, kasa
                            tipi (sedan, hatchback) gibi
                            bilgileri eksiksiz doldurarak,
                            en uygun parçaların listelenmesi
                            sağlanır.
                        </li>
                    </ul>


                </Popover.Content>
            </Popover>
        }
    >
        <Button className="ml-2" variant="default">
            <i className="icon-info" title=""></i>
        </Button>
    </OverlayTrigger>
);

export default SearchPartsInfoOverlay;
